enum ProjectId {
  PMS = 1,
  CRM = 2,
  AGENCY = 5,
  HOUSEKEEPING = 15,
  SCANID = 12,
  POS = 13,
}

enum ProjectName {
  PMS = 'pms',
  CRM = 'crm',
  AGENCY = 'agency',
  HOUSEKEEPING = 'housekeeping',
  SCANID = 'scan-id',
  POS = 'pos',
}

class Project {
  static readonly PMS = new Project(ProjectId.PMS, ProjectName.PMS)
  static readonly CRM = new Project(ProjectId.CRM, ProjectName.CRM)
  static readonly AGENCY = new Project(ProjectId.AGENCY, ProjectName.AGENCY)
  static readonly HOUSEKEEPING = new Project(ProjectId.HOUSEKEEPING, ProjectName.HOUSEKEEPING)
  static readonly SCANID = new Project(ProjectId.SCANID, ProjectName.SCANID)
  static readonly POS = new Project(ProjectId.POS, ProjectName.POS)

  private constructor(
    public readonly id: ProjectId,
    public readonly name: ProjectName,
  ) {}

  static values = (): Project[] => {
    return [
      Project.PMS,
      Project.CRM,
      Project.AGENCY,
      Project.HOUSEKEEPING,
      Project.SCANID,
      Project.POS,
    ]
  }
}

export { ProjectId, ProjectName, Project }
